import React from 'react'

import { Icon, MiniSpinner } from './styles'
import enhance from './enhance'
import themes from './themes'

export const Component = ({
  icon,
  iconText,
  busy,
  label,
  theme,
  onClick,
  children,
  disabled,
  smartComponent: { SmartButton, safeProps },
}) => (
  <SmartButton
    {...safeProps}
    disabled={disabled}
    onClick={disabled ? undefined : onClick}
    kind={theme || 'primary'}
  >
    {label || children}
    {iconText && <p>{iconText}</p>}
    {!!icon &&
      (busy ? (
        <MiniSpinner data-testid="info_buttonSpinner" />
      ) : (
        <Icon name={icon} />
      ))}
  </SmartButton>
)

Component.displayName = 'Button'

export default enhance(Component)
